var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, OnDestroy } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService, AutocompleteService, ScreenService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { fromEvent } from 'rxjs';
import { takeWhile, debounceTime, map, distinctUntilChanged, startWith, tap } from 'rxjs/operators';
import * as fromStore from '../../../store';
import * as MiniIBEActions from '@ibe/store/actions/mini-ibe.actions';
import { INDRASelectAirportModalComponent } from '../select-airport-modal/select-airport-modal.indra.component';
import { INDRAAirportLocationService } from '@ibe.services/airport-location.indra.service';
import { SESSION_VAR_KEY_LANGUAGE, SESSION_VAR_KEY_MARKET, DEFAULT_LANGUAGE, DEFAULT_MARKET } from '@ibe.config';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
var INDRASelectRegionModalComponent = /** @class */ (function (_super) {
    __extends(INDRASelectRegionModalComponent, _super);
    function INDRASelectRegionModalComponent(modalService, store, screen, fetcher, airportLocationService, ibeAdminService) {
        var _this = _super.call(this, modalService) || this;
        _this.modalService = modalService;
        _this.store = store;
        _this.screen = screen;
        _this.fetcher = fetcher;
        _this.airportLocationService = airportLocationService;
        _this.ibeAdminService = ibeAdminService;
        _this.localCountry = 'PT';
        _this.isAlive = true;
        _this.isLoading = false;
        _this.isAirportLoading = false;
        _this.isMobile$ = _this.store.select(fromStore.isScreenMobile);
        _this.isMobile = false;
        _this.activeInput$ = _this.store.select(fromStore.getMiniIBEActiveInput);
        _this.searchRoute$ = _this.store.select(fromStore.getMiniIBESearchRoutes);
        _this.bookAwardFlights$ = _this.store.select(fromStore.getFlightsFilterBookAwardFlights);
        _this.boolean = false;
        _this.routeType$ = _this.store.select(fromStore.getMiniIBERouteType);
        _this.regions = [];
        _this.countries = [];
        _this.countriesOfRegions = [];
        _this.airports = [];
        /**
         * Airport list filtered by this.query;
         */
        _this.results = [];
        _this.selectedRegion = 0; // Open first
        _this.selectedCountry = null; // Open first
        _this.selectedCountryCode = null; // Open first
        _this.isSelectingCountry = false; // To show first on Desktop and wait for user selection on Mobile
        _this.isSelectingAirport = false; // To show first on Desktop and wait for user selection on Mobile
        // private loading$: Observable<boolean> = this.store.select(fromStore.getUserLoading);
        _this.title = 'Departure Airport';
        _this.allSubscriptions = [];
        _this.rawLanguage = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE);
        _this.language = _this.rawLanguage ? (_this.rawLanguage.includes('-') ? _this.rawLanguage.substring(0, 2) : _this.rawLanguage) : DEFAULT_LANGUAGE;
        _this.airportParams = {
            language: _this.language,
            market: sessionStorage.getItem(SESSION_VAR_KEY_MARKET) ?
                sessionStorage.getItem(SESSION_VAR_KEY_MARKET) : DEFAULT_MARKET,
            country: '',
        };
        _this.continentsParams = {
            language: _this.language,
            market: sessionStorage.getItem(SESSION_VAR_KEY_MARKET) ?
                sessionStorage.getItem(SESSION_VAR_KEY_MARKET) : DEFAULT_MARKET,
        };
        _this.continentAPIError = false;
        _this.isMobile$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.isMobile = value;
        });
        _this.resize$ = fromEvent(window, 'resize')
            .pipe(debounceTime(250), map(function () { return window.innerWidth; }), distinctUntilChanged(), startWith(window.innerWidth), tap(function (width) { return _this.screen.setWindowWidth(Number(width)); }));
        _this.activeInput$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.endpoint = value;
            if (_this.modalService.params[0].param) {
                _this.title = _this.INDRA_getTranslation('bookingSearch.label.departure') + " " + _this.INDRA_getTranslation('bookingSearch.text.airport');
                _this.callFromBestOffers = true;
            }
            else {
                if (value) {
                    _this.title = (value === 'from' ? _this.INDRA_getTranslation('bookingSearch.label.departure') : _this.INDRA_getTranslation('bookingSearch.label.arrival')) + " " + _this.INDRA_getTranslation('bookingSearch.text.airport');
                    _this.callFromBestOffers = false;
                }
            }
        });
        _this.searchRoute$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (searchRoute) {
            _this.searchRoute = searchRoute;
            if (searchRoute && searchRoute.length &&
                searchRoute[0].departure && searchRoute[0].departure.location &&
                searchRoute[0].departure.location.cityName) {
                _this.selectedDepartureAirport = searchRoute[0].departure.location.cityName === searchRoute[0].departure.code ? searchRoute[0].departure.location.cityName : searchRoute[0].departure.code;
            }
        });
        _this.bookAwardFlights$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) { return _this.bookAwardFlights = value; });
        _this.routeType$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (routeType) { return _this.routeType = routeType; });
        return _this;
    }
    INDRASelectRegionModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        var continentsParams = this.INDRA_generatePayload(this.continentsParams);
        this.isLoading = true;
        this.continentsSubscription =
            this.airportLocationService.INDRAGetContinents(continentsParams).subscribe(function (response) {
                if (response.status === '200' && response && response.Continents) {
                    _this.regions = response.Continents;
                    // adds an id to regions
                    _this.regions.forEach(function (element) { return element.id = element.name.toLowerCase().replace('and', '').replace(/\s+/g, '_'); });
                    _this.continentAPIError = false;
                }
                else {
                    _this.continentAPIError = true;
                }
                _this.isLoading = false;
            }, function (err) {
                _this.isLoading = false;
                _this.continentAPIError = true;
            });
        this.allSubscriptions.push(this.continentsSubscription);
        //this.loading$.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
        //	this.isLoading = value;
        //});
        this.resize$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe();
    };
    INDRASelectRegionModalComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
        for (var _i = 0, _a = this.allSubscriptions; _i < _a.length; _i++) {
            var sub = _a[_i];
            if (sub) {
                sub.unsubscribe();
            }
        }
    };
    /**
     * Handles a response and translates it for the template results
     * @param res data got from response
     * @returns data as expected for the template
     */
    INDRASelectRegionModalComponent.prototype.handleData = function (res) {
        if (res instanceof Array) {
            return res;
        }
        else {
            return res.data.origins;
        }
    };
    INDRASelectRegionModalComponent.prototype.closeModal = function () {
        this.modalService.close();
        if (this.isMobile) {
            this.modalService.assignComponent(INDRASelectAirportModalComponent);
            this.modalService.open();
        }
    };
    INDRASelectRegionModalComponent.prototype.backMobile = function () {
        if (this.isSelectingCountry) {
            this.isSelectingCountry = false;
        }
        else if (this.isSelectingAirport) {
            this.isSelectingAirport = false;
            this.isSelectingCountry = true;
        }
        else {
            this.closeModal();
        }
    };
    INDRASelectRegionModalComponent.prototype.INDRA_printTitle = function () {
        return this.title;
    };
    INDRASelectRegionModalComponent.prototype.INDRA_printSubTitle = function () {
        if (!this.isSelectingCountry && !this.isSelectingAirport) {
            return this.INDRA_getTranslation('bookingSearch.text.region');
        }
        else if (this.isSelectingCountry) {
            return this.regions[this.selectedRegion].name;
        }
        else if (this.isSelectingAirport) {
            return this.countriesOfRegions[this.selectedCountry].name;
        }
    };
    INDRASelectRegionModalComponent.prototype.INDRAgetRegionCountries = function () {
        var _this = this;
        this.countries = this.regions.filter(function (country) {
            if (country.name === _this.regions[_this.selectedRegion].name) {
                _this.countriesOfRegions = country.countries;
            }
        });
        return this.countriesOfRegions;
    };
    INDRASelectRegionModalComponent.prototype.getCountryAirports = function () {
        if (this.selectedCountry !== null) {
            return this.airports;
        }
        else {
            return;
        }
    };
    INDRASelectRegionModalComponent.prototype.INDRA_handleSelectRegionClick = function (regionIndex) {
        this.selectedRegion = regionIndex;
        this.isSelectingCountry = true;
    };
    INDRASelectRegionModalComponent.prototype.INDRA_handleSelectCountryClick = function (countryCode) {
        var _this = this;
        this.isAirportLoading = true;
        this.airports = [];
        this.selectedCountry = this.countriesOfRegions.findIndex(function (country) { return country.code === countryCode; });
        this.selectedCountryCode = countryCode;
        this.isSelectingCountry = false;
        this.isSelectingAirport = true;
        if (countryCode) {
            this.airportParams.country = this.selectedCountryCode;
            var airportParams = this.INDRA_generatePayload(this.airportParams);
            this.airportsSubscription =
                this.airportLocationService.INDRAGetAirports(airportParams).subscribe(function (response) {
                    if (response.status === '200' && response && response.airports) {
                        _this.airports = response.airports;
                    }
                    _this.isAirportLoading = false;
                }, function (err) {
                    _this.isAirportLoading = false;
                });
            this.allSubscriptions.push(this.airportsSubscription);
        }
        else {
            this.isAirportLoading = false;
            return null;
        }
    };
    INDRASelectRegionModalComponent.prototype.INDRA_handleSelectAirportClick = function (airport, index) {
        if (index === void 0) { index = 0; }
        var newAirport = {
            name: airport.airportName,
            code: airport.airportCode,
            label: airport.airportName,
            direct: null,
            location: {
                city: airport.cityName,
                country: this.countriesOfRegions[this.selectedCountry].name,
                cityName: airport.airportCode,
                alias: null,
                countryName: this.countriesOfRegions[this.selectedCountry].code
            },
            milesAndGo: null
        };
        // if (this.data && this.data[0] && this.data[0].handleClose) {
        this.data[0].handleClose(newAirport);
        // } else {
        if (this.callFromBestOffers) {
            this.store.dispatch(new MiniIBEActions.PutActiveInput('from'));
            this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
            this.store.dispatch(new MiniIBEActions.PutSearchRoute(newAirport));
        }
        else {
            this.store.dispatch(new MiniIBEActions.PutActiveInput(this.endpoint));
            this.store.dispatch(new MiniIBEActions.PutSearchRoute(newAirport));
            this.store.dispatch(new MiniIBEActions.PutCurrentSearchRoute(index));
        }
        // }
        this.modalService.close();
    };
    INDRASelectRegionModalComponent.prototype.INDRA_generatePayload = function (param) {
        var payload = param;
        payload.tripType = this.routeType;
        payload.payWithMiles = this.bookAwardFlights;
        if (this.data && this.data[0] && this.data[0].params) {
            var field = this.data[0].params.id;
            var index = field.slice(field.length - 1);
            if (isNaN(index)) {
                // rt/ow
                if (field.includes('from') || field.includes('departure')) {
                    payload.isOrigin = true;
                }
                if (field.includes('to') || field.includes('arrival')) {
                    payload.isDestination = true;
                    payload.originAirport = this.selectedDepartureAirport;
                }
            }
            else {
                // multicity
                if (index == 0 && field.includes('from')) {
                    payload.isOrigin = true;
                }
                else {
                    // payload.isMulticity = true;
                    payload.isDestination = true;
                    if (this.searchRoute && this.searchRoute.length) {
                        var route = field.includes('from') ? this.searchRoute[+index - 1] : this.searchRoute[+index];
                        var prevDest = route ? field.includes('from') ? route.arrival ? route.arrival.code : '' : route.departure ? route.departure.code : '' : '';
                        // payload.previousDestination = prevDest;
                        payload.originAirport = prevDest;
                    }
                }
            }
        }
        return payload;
    };
    INDRASelectRegionModalComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRASelectRegionModalComponent.prototype.INDRA_printErrorMessage = function () {
        return this.INDRA_getTranslation('bookingSearch.text.tryAgainLater');
    };
    return INDRASelectRegionModalComponent;
}(AbstractModalContentComponent));
export { INDRASelectRegionModalComponent };
